import { useMutation } from "@tanstack/react-query";
import { generateEmailResponse } from "../services/karliApiService";
import { getEmailContent } from "../utils/emailUtils";
import { useAuth } from "../contexts/AuthContext";
import { GenerateEmailParams } from "../types";
import { UseCase } from "../types/useCase";

interface GenerateResponseParams {
  assistant: string;
  agentId?: string;
  userContext?: string;
  source?: string;
  selectedCase: UseCase;
}

export function useGenerateResponse<TResponse = any>() {
  const { getValidAccessToken } = useAuth();

  return useMutation<TResponse, Error, GenerateResponseParams>({
    mutationFn: async (params: GenerateResponseParams) => {
      const accessToken = await getValidAccessToken();

      const emailContent = await getEmailContent();
      if (!emailContent || emailContent.trim().length === 0) {
        throw new Error("Kein E-Mail-Inhalt gefunden.");
      }

      const requestParams: GenerateEmailParams & { selectedCase: UseCase } = {
        emailContent,
        assistant: params.assistant,
        accessToken,
        agentId: params.agentId,
        userContext: params.userContext,
        source: "OUTLOOK",
        selectedCase: params.selectedCase as UseCase,
      };

      return generateEmailResponse(requestParams) as Promise<TResponse>;
    },
    retry: 1,
  });
}
